import {View} from 'backbone.marionette';
import template from '../templates/emptyBasket.hbs';

class EmptyBasket extends View.extend({
  template: template
}) {}

export default EmptyBasket;
